import { StorageOfUniqueServices } from '@qality/common-service';

export default {
  async getServerInfo() {
    return await StorageOfUniqueServices.get('API')
      .request({
        url: '/rest/api/2/serverInfo',
        type: 'GET',
        contentType: 'application/json',
      })
      .then((response) => {
        return JSON.parse(response.body);
      });
  },
};
